<template>
  
  <div>
    <el-container>
      <el-header style="height:85px" class="gudin">
      <h1> 协议规则</h1>
      </el-header>
      <el-main>
        <div class="card" v-html="templateHtml">
        
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import topHead from "./components/topHead.vue";

export default {
  data() {
    return {
      detalis: null,
      flag: false,
      detalisProps: null,
      templateHtml:''
    };
  },
  components: {
    topHead,
    
  },
  created() {
   this.getData()
  },
  methods: {
     getData(){
      let params = {
        serial_number: this.$route.query.company_id
      };
      this.$axios.postJSON("/base/invite/detail", params).then(res => {
            if (res.code == 200) {
              this.getMgt(res.data.company_id);
            }
          });
    },
    // 请求激活接口
    getMgt(id) {
      this.$axios.get("/setting/shortlisted", { company_id:id }).then(res => {
        if (res.code == 200) {
          let data = res.data.agreement_list.find(i=>{
            if(this.$route.query.id == i.id){
              return i
            }
          })
        this.templateHtml = data.content
         
          
        }
      });
    },
   
    
  }
};
</script>

<style lang="scss" scoped>
.el-container {
  width: 100%;

  .el-header {
    // background-color: #b3c0d1;
    color: #333;
    text-align: center;
    line-height: 85px;
    margin: auto;
    background-color: rgba(255, 255, 255, 100);
    box-shadow: 0px 2px 6px 4px rgba(0, 0, 0, 0.1);
  }
  .el-main {
    margin: auto;

    text-align: center;
    .card {

        padding: 50px;
      width: 80%;

       margin: auto;
       margin-top: 100px;
      margin-bottom: 30px;
      background-color: #fff;
     min-height: 500px;
     
    }
  }
}
.gudin{
    width: 100%;
    position: fixed;
    top: 0;
    
}

</style>